import Swiper from "swiper";
import { Thumbs, Controller, Autoplay } from "swiper/modules"; // Removed Navigation

document.addEventListener("DOMContentLoaded", () => {
  const mainProductsContainerSelector = ".featured-products-main";
  const thumbsProductsContainerSelector = ".featured-products-thumbs";
  const mainProductsEl = document.querySelector(mainProductsContainerSelector);
  const thumbsProductsEl = document.querySelector(
    thumbsProductsContainerSelector
  );

  const MOBILE_BREAKPOINT = 768; // Match SCSS breakpoint

  if (mainProductsEl && thumbsProductsEl) {
    let thumbsSwiper = null;
    let mainSwiper = null;

    function initSwipers() {
      // Destroy existing instances if they exist
      if (thumbsSwiper && typeof thumbsSwiper.destroy === "function") {
        thumbsSwiper.destroy(true, true);
        thumbsSwiper = null;
      }
      if (mainSwiper && typeof mainSwiper.destroy === "function") {
        mainSwiper.destroy(true, true);
        mainSwiper = null;
      }

      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      thumbsSwiper = new Swiper(thumbsProductsEl, {
        modules: [Controller],
        spaceBetween: 10,
        slidesPerView: isMobile ? 3.5 : 4, // Show more thumbs if horizontal on mobile
        freeMode: true,
        watchSlidesProgress: true,
        direction: isMobile ? "horizontal" : "vertical",
        centerInsufficientSlides: true,
      });

      mainSwiper = new Swiper(mainProductsEl, {
        modules: [Thumbs, Controller, Autoplay], // Removed Navigation
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        // Navigation configuration removed
        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    }

    // Initial setup
    initSwipers();

    // Re-initialize on resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initSwipers();
      }, 250);
    });
  }
});
